// src/Routes.jsx
import React from "react";
import { BrowserRouter, Navigate, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import ProtectedRoute from "components/ProtectedRoute";

// Page imports
import Homepage from "pages/homepage";
import PropertyListings from "pages/property-listings";
import PropertyDetails from "pages/property-details";
import AdminDashboard from "pages/admin-dashboard";
import AgentDashboard from "pages/agent-dashboard";
import GeneralManagementSettings from "pages/general-management-settings";
import UserProfileSettings from "pages/user-profile-settings";
import LoginPage from "pages/login";
import LinkAgrochainAccountPage from "pages/link-agrochain-account";
import SignupPage from "pages/signup";
import NotFound from "pages/NotFound";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          <Route path="/" element={<Homepage />} />
          <Route path="/homepage" element={<Homepage />} />
          <Route path="/property-listings" element={<PropertyListings />} />
          <Route path="/product-listings" element={<PropertyListings />} />
          <Route path="/property-details" element={<PropertyDetails />} />
          <Route path="/product-details" element={<PropertyDetails />} />
          <Route
            path="/agent-dashboard"
            element={
              <ProtectedRoute allowedRoles={["SUPERADMIN"]}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/market-dashboard"
            element={
              <ProtectedRoute allowedRoles={["MARKET_USER"]}>
                <AgentDashboard />
              </ProtectedRoute>
            }
          />
          <Route path="/dashboard" element={<Navigate to="/market-dashboard" replace />} />
          <Route
            path="/user-profile-settings"
            element={
              <ProtectedRoute>
                <UserProfileSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/general-management-settings"
            element={
              <ProtectedRoute allowedRoles={["SUPERADMIN"]}>
                <GeneralManagementSettings />
              </ProtectedRoute>
            }
          />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/link-agrochain-account" element={<LinkAgrochainAccountPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
